import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import PaginatedEntityTable from "components/common/PaginatedEntityTable";
import QueryHelper from "components/common/QueryHelper";
import { Alert } from "components/bootstrap";
import { Link, Spinner } from "components/common";
import IlluminateRoutes from "illuminate/Routes";
import { fetchDetectionChains } from "security-app/hooks/api/detectionChainsAPI";
import { useGetDetectionChains } from "security-app/hooks/useDetectionChainsAPI";
import DetectionChainRowActions from "./DetectionChainRowActions";
import columnRenderers from "./columnRenderers";
import useTableComponents from "./useTableComponents";
import { ATTRIBUTES, listElements } from "./constants";
const detectionChainsKeyFn = (searchParams) => {
  var _a, _b, _c, _d, _e, _f, _g;
  return [
    "detection-chains",
    "paginated",
    (_a = searchParams.page) != null ? _a : 1,
    (_b = searchParams.pageSize) != null ? _b : listElements.defaultLayout.defaultPageSize,
    (_c = searchParams.query) != null ? _c : "",
    (_e = (_d = searchParams.sort) == null ? void 0 : _d.attributeId) != null ? _e : "name",
    (_g = (_f = searchParams.sort) == null ? void 0 : _f.direction) != null ? _g : "asc"
  ];
};
const fetchEntities = async (searchParams) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const response = await fetchDetectionChains({
    page: (_a = searchParams.page) != null ? _a : 1,
    per_page: (_b = searchParams.pageSize) != null ? _b : listElements.defaultLayout.defaultPageSize,
    query: (_c = searchParams.query) != null ? _c : "",
    sort: (_e = (_d = searchParams.sort) == null ? void 0 : _d.attributeId) != null ? _e : "name",
    direction: (_g = (_f = searchParams.sort) == null ? void 0 : _f.direction) != null ? _g : "asc"
  });
  return {
    list: response.detection_chains,
    pagination: { total: response.total },
    attributes: ATTRIBUTES
  };
};
const renderActions = (chain) => /* @__PURE__ */ React.createElement(DetectionChainRowActions, { chain });
const DETECTION_CHAINS_PACK_SEARCH = "Windows Detection Chains";
const illuminatePacksLink = `${IlluminateRoutes.LIST}?query=${encodeURIComponent(DETECTION_CHAINS_PACK_SEARCH)}`;
const EmptyState = () => {
  const { t } = useTranslation("enterprise_security_sigma");
  return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info" }, /* @__PURE__ */ React.createElement("p", null, t("list.empty_state.none_installed")), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "list.empty_state.install_hint",
      components: { illuminateLink: /* @__PURE__ */ React.createElement(Link, { to: illuminatePacksLink }) }
    }
  )));
};
const List = () => {
  const { t } = useTranslation("enterprise_security_sigma");
  const humanName = t("list.human_name");
  const { expandedSections } = useTableComponents();
  const { data: countData, isLoading: countLoading } = useGetDetectionChains({ page: 1, per_page: 1 });
  if (countLoading) return /* @__PURE__ */ React.createElement(Spinner, { text: t("list.loading") });
  if ((countData == null ? void 0 : countData.total) === 0) return /* @__PURE__ */ React.createElement(EmptyState, null);
  return /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName,
      tableLayout: listElements.defaultLayout,
      queryHelpComponent: /* @__PURE__ */ React.createElement(QueryHelper, { entityName: t("list.query_entity_name"), commonFields: ["name", "description"] }),
      fetchEntities,
      keyFn: detectionChainsKeyFn,
      expandedSectionRenderers: expandedSections,
      entityAttributesAreCamelCase: false,
      columnRenderers,
      entityActions: renderActions
    }
  );
};
export default List;
